import React, { useEffect, useState } from 'react';
import {
    Grid,
    Card,
    CircularProgress,
    Box
} from '@mui/material';
import { Line, Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';
import axios from './../../axios/api';

// Register the necessary components and scales with ChartJS
ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    ArcElement,
    Title,
    Tooltip,
    Legend
);

const DashboardPage = () => {
    const [lineChartData, setLineChartData] = useState({ labels: [], datasets: [] });
    const [pieChartData, setPieChartData] = useState({ labels: [], datasets: [] });
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchData();

    }, []);

    const fetchData = async () => {
        try {
            setIsLoading(true);

            const lineChartUrl = `/admin/dashboard/get-latest-user-register-count`;
            const pieChartUrl = `/admin/dashboard/get-count`;

            const [lineChartRes, pieChartRes] = await Promise.all([
                axios.get(lineChartUrl,),
                axios.get(pieChartUrl,)
            ]);

            const lineChartData = lineChartRes.data?.data;
            const pieChartData = pieChartRes.data?.data;

            if (lineChartData) {
                const labels = Object.keys(lineChartData).map(date => date);
                const values = Object.values(lineChartData);

                // Add empty labels at the start and end to create margin for line chart
                const extendedLabels = ['', ...labels, ''];
                const extendedValues = [null, ...values, null];

                setLineChartData({
                    labels: extendedLabels,
                    datasets: [
                        {
                            label: 'آخرین تعداد ثبت نام کاربر',
                            backgroundColor: 'rgba(75,192,192,0.2)',
                            borderColor: 'rgba(75,192,192,1)',
                            data: extendedValues,
                        }
                    ]
                });
            }

            if (pieChartData) {
                const labels = Object.keys(pieChartData).map(date => date);
                const values = Object.values(pieChartData);

                setPieChartData({
                    labels,
                    datasets: [
                        {
                            label: 'تعداد ثبت نام کاربر',
                            backgroundColor: [
                                'rgba(255,99,132,0.2)',
                                'rgba(54,162,235,0.2)',
                                'rgba(255,206,86,0.2)',
                                'rgba(75,192,192,0.2)',
                                'rgba(153,102,255,0.2)',
                                'rgba(255,159,64,0.2)'
                            ],
                            borderColor: [
                                'rgba(255,99,132,1)',
                                'rgba(54,162,235,1)',
                                'rgba(255,206,86,1)',
                                'rgba(75,192,192,1)',
                                'rgba(153,102,255,1)',
                                'rgba(255,159,64,1)'
                            ],
                            borderWidth: 1,
                            data: values,
                        }
                    ]
                });
            }

        } catch (e) {
            console.log('Request canceled', e);

        } finally {
            setIsLoading(false);
        }
    };

    const lineOptions = {
        scales: {
            x: {
                type: 'category',
                ticks: {
                    autoSkip: false, // Prevent auto-skipping of ticks
                    font: {
                        family: 'IranSans', // Change to your desired font family
                    },
                },
            },
            y: {
                beginAtZero: true,
                ticks: {
                    precision: 0, // Remove floating-point numbers
                    font: {
                        family: 'IranSans', // Change to your desired font family
                    },
                },
            },
        },
        plugins: {
            legend: {
                labels: {
                    font: {
                        family: 'IranSans', // Change to your desired font family
                    },
                },
            },
            tooltip: {
                bodyFont: {
                    family: 'IranSans', // Change to your desired font family
                },
                titleFont: {
                    family: 'IranSans', // Change to your desired font family
                },
            },
        },
        layout: {
            padding: {
                left: 0,
                right: 0,
                top: 0,
                bottom: 0
            }
        },
        responsive: true,
        maintainAspectRatio: false
    };

    const pieOptions = {
        plugins: {
            legend: {
                labels: {
                    font: {
                        family: 'IranSans', // Change to your desired font family
                    },
                },
            },
            tooltip: {
                bodyFont: {
                    family: 'IranSans', // Change to your desired font family
                },
                titleFont: {
                    family: 'IranSans', // Change to your desired font family
                },
            },
        },
        responsive: true,
        maintainAspectRatio: false
    };

    return (
        <Grid container spacing={2} sx={{ direction: 'ltr' }}>
            <Grid item lg={12} md={12} sm={12}>
                <Card variant="outlined">
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Line data={lineChartData} options={lineOptions} />
                    )}
                </Card>
            </Grid>
            <Grid item lg={12} md={12} sm={12}>
                <Card variant="outlined">
                    {isLoading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Pie data={pieChartData} options={pieOptions} />
                    )}
                </Card>
            </Grid>
        </Grid>
    );
};

export default DashboardPage;
